module.exports = __webpack_public_path__ + "static/img/2_2_1_1.87b60b61.jpg";